import SystemAdmin from '../views/SystemAdmin';
import AdminSettings from '../views/admin/settings/Index';
import AdminSettingsGeneral from '../views/admin/settings/General';
import AdminSettingsStripe from '../views/admin/settings/Stripe';
import AdminHouseholds from '../views/admin/households/Index';
import AdminPartnerships from '../views/admin/partnerships/Index';
import AdminPartnershipsEdit from '../views/admin/partnerships/Edit';
import AdminAffiliatesList from '../views/admin/affiliates/List';
import AdminAffiliatesStatistic from '../views/admin/affiliates/Statistics';
import AdminAffiliatesEdit from '../views/admin/affiliates/Edit';
import AdminAffiliatesCommissions from '../views/admin/affiliates/Commissions';
import AdminClients from '../views/admin/clients/Index';
import AdminsList from '../views/admin/admins/Index';
import EditAdmin from '../views/admin/admins/EditAdmin';
import ManageJumpStart from '../views/admin/jump-start/Index';
import EditVideo from '../views/admin/jump-start/EditVideo';
import EditFolder from '../views/admin/jump-start/EditFolder';

const prefix = 'system-admin';

export const SYSTEM_ADMIN_ROUTES = {
  path: `/${prefix}`,
  name: prefix,
  redirect: { name: `${prefix}-general` },
  component: SystemAdmin,
  meta: { title: 'Admin - Settings' },
  children: [
    {
      path: 'settings',
      name: `${prefix}-general`,
      component: AdminSettings,
      meta: { title: 'Admin - Settings' },
      children: [
        {
          path: '',
          name: 'admin-settings',
          component: AdminSettingsGeneral,
          meta: { title: 'Admin - Settings - General' }
        },
        {
          path: 'stripe',
          name: 'admin-settings-stripe',
          component: AdminSettingsStripe,
          meta: { title: 'Admin - Settings - Stripe' }
        }
      ]
    },
    {
      path: 'admins',
      name: `${prefix}-admins`,
      component: AdminsList,
      meta: { title: 'Admin - Settings - Admins' }
    },
    {
      path: 'admins/new',
      name: `${prefix}-admins-add`,
      component: EditAdmin,
      meta: { title: 'Admin - Add Admin' }
    },
    {
      path: 'admins/:admin_id',
      name: `${prefix}-admins-edit`,
      component: EditAdmin,
      meta: { title: 'Admin - Edit Admin' }
    },
    {
      path: 'households',
      name: `${prefix}-households`,
      component: AdminHouseholds,
      meta: { title: 'Admin - All Households' }
    },
    {
      path: 'partnerships',
      name: `${prefix}-partnerships`,
      component: AdminPartnerships,
      meta: { title: 'Admin - All Partnerships' }
    },
    {
      path: 'partnerships/new',
      name: `${prefix}-partnerships-create`,
      component: AdminPartnershipsEdit,
      meta: { title: 'Admin - Add New Partnership' }
    },
    {
      path: 'partnerships/:partnership_id',
      name: `${prefix}-partnerships-edit`,
      component: AdminPartnershipsEdit,
      meta: { title: 'Admin - Edit Partnership' }
    },
    {
      path: 'affiliates',
      name: `${prefix}-affiliates`,
      redirect: { name: `${prefix}-affiliates-list` },
    },
    {
      path: 'affiliates/list',
      name: `${prefix}-affiliates-list`,
      component: AdminAffiliatesList,
      meta: { title: 'Admin - All Affiliates' }
    },
    {
      path: 'affiliates/statistic',
      name: `${prefix}-affiliates-statistic`,
      component: AdminAffiliatesStatistic,
      meta: { title: 'Admin - Affiliates Statistic' }
    },
    {
      path: 'affiliates/new',
      name: `${prefix}-affiliates-create`,
      component: AdminAffiliatesEdit,
      meta: { title: 'Admin - Add New Affiliate' }
    },
    {
      path: 'affiliates/:affiliate_id',
      name: `${prefix}-affiliates-edit`,
      component: AdminAffiliatesEdit,
      meta: { title: 'Admin - Edit Affiliate' }
    },
    {
      path: 'affiliates/:affiliate_id/commissions',
      name: `${prefix}-affiliates-commissions`,
      component: AdminAffiliatesCommissions,
      meta: { title: 'Admin - Affiliate Commissions' }
    },
    // {
    //   path: 'policies',
    //   name: 'admin-policies',
    //   component: AdminPolicies,
    //   meta: { title: 'Admin - All Policies' }
    // },
    {
      path: 'clients',
      name: `${prefix}-clients`,
      component: AdminClients,
      meta: { title: 'Admin - All Clients' }
    },
    // {
    //   path: 'stripe',
    //   name: `${prefix}-stripe`,
    //   component: AdminSettingsStripe,
    //   meta: { title: 'Admin - Settings - Stripe' }
    // },
    {
      path: 'jump-start',
      name: `${prefix}-jump-start`,
      component: ManageJumpStart,
      meta: { title: 'Manage Jump Start' },
    },
    {
      path: 'jump-start/videos/:id',
      name: `${prefix}-video-edit`,
      component: EditVideo,
      meta: { title: 'Edit Video' },
    },
    {
      path: 'jump-start/videos/new',
      name: `${prefix}-video-add`,
      component: EditVideo,
      meta: { title: 'Create Video' },
    },
    {
      path: 'jump-start/folders/:id',
      name: `${prefix}-folder-edit`,
      component: EditFolder,
      meta: { title: 'Edit Folder' },
    },
    {
      path: 'jump-start/folders/new',
      name: `${prefix}-folder-add`,
      component: EditFolder,
      meta: { title: 'Create Folder' },
    },
  ],
};
